import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Col, Row, Tab, Form, Button, Modal } from "react-bootstrap";
import swal from "sweetalert";
import { GlobalContext } from "../../Context/GlobalState";
import { billpunchbasicauth } from "../../utils/Credentials";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
import { uniqueID } from "../../utils/utilFuctions";
const EmployeeFormAdmin = () => {
    const navigate = useNavigate();
    const [employeeTypes, setEmployeeTypes] = useState([]);
    const [showTypeModal, setShowTypeModal] = useState(false);
  const [newEmpType, setNewEmpType] = useState("");
  const [verificationMessage, setVerificationMessage] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [banks, setBanks] = useState([]);
  const [selectedBank, setSelectedBank] = useState({ bankName: "", ifsc: "" });
  const { password, username } = billpunchbasicauth;
  const { user } = useContext(GlobalContext);
  const [departmentData, setDepartmentData] = useState([]);
  const { setTransactionLoaderState } = useContext(GlobalContext);
  const [formData, setFormData] = useState({
    firmid: "",
    firstname: "",
    middlename: "",
    lastname: "",
    mobile: "",
    designation: "",
    department: "",
    emp_type: "",
    address: "",
    email: "",
    dob: "",
    epf_no: "",
    aadharno: "",
    panno: "",
    joiningdate: "",
    bankName: "",
    accountNumber: "",
    // ifscCode: "",
    workemail: "",
    pan: "",
    qualification: "",
  });
  const [errors, setErrors] = useState({
    firmid: "",
    firstname: "",
    middlename: "",
    lastname: "",
    mobile: "",
    designation: "",
    department: "",
    emp_type: "",
    address: "",
    email: "",
    dob: "",
    epf_no: "",
    aadharno: "",
    panno: "",
    joiningdate: "",
    bankName: "",
    accountNumber: "",
    // ifscCode: "",
    workemail: "",
    pan: "",
    qualification: "",
  });
  const validate = (e) => {
    e.preventDefault();
    // console.log(" validate function");
    // console.log(formData);
    let errors = {};

    const spaceRegex = /^\s+/;

    if (spaceRegex.test(formData.firstname)) {
      errors.firstname = "*First name should not start with a space";
    } else if (formData.firstname.trim() === "") {
      errors.firstname = "*Please enter first Name";
    }

    if (spaceRegex.test(formData.lastname)) {
      errors.lastname = "*Last name should not start with a space";
    } else if (formData.lastname.trim() === "") {
      errors.lastname = "*Please enter last name";
    }

    if (spaceRegex.test(formData.mobile)) {
      errors.mobile = "*Mobile should not start with a space";
    } else if (formData.mobile.trim() === "") {
      errors.mobile = "*Please enter Mobile";
    }

    if (spaceRegex.test(formData.email)) {
      errors.email = "*Email should not start with a space";
    } else if (formData.email.trim() === "") {
      errors.email = "*Please enter Email";
    }

    if (spaceRegex.test(formData.address)) {
      errors.address = "*Address should not start with a space";
    } else if (formData.address.trim() === "") {
      errors.address = "*Please enter Address";
    }

    if (spaceRegex.test(formData.designation)) {
      errors.designation = "*Designation should not start with a space";
    } else if (formData.designation.trim() === "") {
      errors.designation = "*Please enter Designation";
    }

    if (!formData.dob || spaceRegex.test(formData.dob.toString())) {
      errors.dob = "*Please select a valid Date of Birth";
    }

    if (spaceRegex.test(formData.department)) {
      errors.department = "*Department should not start with a space";
    } else if (formData.department.trim() === "") {
      errors.department = "*Please select Department";
    }

    if (spaceRegex.test(formData.emp_type)) {
      errors.emp_type = "*Employee type should not start with a space";
    } else if (formData.emp_type.trim() === "") {
      errors.emp_type = "*Please select employee type";
    }

    if (
      !formData.joiningdate ||
      spaceRegex.test(formData.joiningdate.toString())
    ) {
      errors.joiningdate = "*Please select a valid Joining Date";
    }

    if (spaceRegex.test(formData.bankName)) {
      errors.bankName = "*Bank Name should not start with a space";
    } else if (formData.bankName.trim() === "") {
      errors.bankName = "*Please enter Bank Name";
    }

    if (spaceRegex.test(formData.accountNumber)) {
      errors.accountNumber =
        "*Bank Account Number should not start with a space";
    } else if (formData.accountNumber.trim() === "") {
      errors.accountNumber = "*Please enter Bank Account Number";
    }

    if (spaceRegex.test(formData.workemail)) {
      errors.workemail = "*Work email should not start with a space";
    } else if (formData.workemail.trim() === "") {
      errors.workemail = "*Please enter Work email";
    }

    if (spaceRegex.test(formData.pan)) {
      errors.pan = "*Pan should not start with a space";
    } else if (formData.pan.trim() === "") {
      errors.pan = "*Please enter Pan";
    }

    if (spaceRegex.test(formData.qualification)) {
      errors.qualification = "*Qualification should not start with a space";
    } else if (formData.qualification.trim() === "") {
      errors.qualification = "*Please enter Qualification";
    }

    if (!formData.joiningdate) {
      errors.joiningdate = "*Please select a valid Joining Date";
    }
    if (!formData.dob) {
      errors.dob = "*Please select a valid Date of Birth";
    }
    setErrors(errors);
    console.log("Validation Errors:", errors);
    console.log("handle change button 1 ");
    if (Object.keys(errors).length === 0) {
      handleSubmit();
      console.log("handle change button n ");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "bankName") {
      const foundBank = banks.find((bank) => bank.bankName === value);
      setSelectedBank(foundBank || { bankName: "", ifsc: "" });
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };
  const GetEmployeetype = async () => {
    setTransactionLoaderState(true);
  
    try {
      const base64Credentials = btoa(`${username}:${password}`);
  
      const raw = JSON.stringify({
        firmid: user.firm_id,
      });
  
      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };
  
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetEmployeetype`,
        requestOptions
      );
  
      const data = await res.json();
  
      if (data.status === "0") {
        setEmployeeTypes(data.data);
      }
  
    } catch (error) {
      console.log("error", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };
  const getDepartmentList = async () => {
    setTransactionLoaderState(true);
    try {
        const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({ firmid: user.firm_id });

      var requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/getEmployeeDepartment`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setDepartmentData(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
    }
  };
  const handleAddEmployeeType = async () => {
    try {
      const base64Credentials = btoa(`${username}:${password}`);
  
      const raw = JSON.stringify({
        firmid: user.firm_id,
        type: newEmpType,
      });
  
      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
      };
  
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/Addemployeetype`,
        requestOptions
      );
  
      const data = await res.json();
  
      if (data.status === "0") {
        alert("Employee Type Added Successfully");
  
        setShowTypeModal(false);
        setNewEmpType("");
  
        GetEmployeetype();
      }
  
    } catch (error) {
      console.log(error);
    }
  };
  const formatDateString = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = ("0" + (d.getMonth() + 1)).slice(-2);
    const day = ("0" + d.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  };

  const handleSubmit = async (e) => {
    try {
      console.log("Inside handleSubmit");
  
      const base64Credentials = btoa(`${username}:${password}`);
   
      const sanitize = (value) =>
        typeof value === "string" ? value.trim() : value;
  
      const raw = JSON.stringify({
        firm_id: user.firm_id,
        firstname: sanitize(formData.firstname),
        middlename: sanitize(formData.middlename),
        lastname: sanitize(formData.lastname),
        mobile: sanitize(formData.mobile),
        designation: sanitize(formData.designation),
        department: sanitize(formData.department),
        emp_type: sanitize(formData.emp_type),
        address: sanitize(formData.address),
        work_email: sanitize(formData.workemail),
        email: sanitize(formData.email),
        dob: formatDateString(formData.dob),
        joiningdate: formatDateString(formData.joiningdate),
        bankname: sanitize(formData.accountNumber),
        bankifsc: sanitize(formData.ifscCode),
        bankaccno: sanitize(formData.bankName),
        qualification: sanitize(formData.qualification),
        pan: sanitize(formData.pan),
      });
  
      console.log("Request sending:", raw);
  
      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };
  
      console.log("sending data to abhijeet");
  
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/addEmployee`,
        requestOptions
      );
  
      const data = await res.json();
      console.log("nishant", data);
  
      if (data.status === "1") {
        swal("Error", data.msg, "error");
      } else {
        swal("Success", data.msg, "success");
      }
  
 
      navigate("/admin/employee-management");
    } catch (error) {
      console.log("Error:", error);
    }
  };
  
  const handleVerification = async () => {
    setTransactionLoaderState(true);
    const { accountNumber, ifscCode } = formData;

    if (!accountNumber || !ifscCode) {
      setErrors({
        ifscCode: !ifscCode ? "IFSC Code is required" : "",
        accountNumber: !accountNumber ? "Account number is required" : "",
      });
      setTransactionLoaderState(false);
      return;
    }
    const requestData = {
      bank_acc_no: accountNumber,
      bank_ifsc_code: ifscCode,
      refrence_id: uniqueID(),
    };
    const auth = btoa("admin@billpunch.com:Billpunch@12345");
    try {
      const response = await fetch(
        "https://apiservices.bumppypay.com/api/Verification/bankVerification",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${auth}`,
          },
          body: JSON.stringify(requestData),
        }
      );
      const data = await response.json();
      if (data && data.responseCode === "00") {
        setIsVerified(true);
        setVerificationMessage(
          `Successfully verified as: ${data.data.bank_holder_name}`
        );
      } else {
        setVerificationMessage("");
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.error("Error verifying bank details:", error);
      setVerificationMessage("");
      setTransactionLoaderState(false);
    }
  };

  useEffect(() => {
    getDepartmentList();
    GetEmployeetype();
  }, []);

  return (
    <>
      <div className="row m-1  d-flex " style={{ justifyContent: "center" }}>
        <div
          className="col-md-8 col-sm-12 m-0 card"
          style={{ borderRadius: ".4rem", justifyContent: "center" }}
        >
          {" "}
          <div style={{ display: "flex", justifyContent: "end" }}>
            <Link to={"/admin/employee-management"} className="mr-md-4">
              {" "}
              <Button
                type="button"
                className="mt-md-2 mr-md-5  btn-sm btn-primary"
                style={{
                  color: "#fff",
                  border: "none",
                }}
              >
                Back
              </Button>
            </Link>
          </div>
          <div className="tab-custom-pills-horizontal ">
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
              <Row className="p-0 m-0">
                <Col xs={12}>
                  <form onSubmit={validate} className="mx-md-5 m-md-2 ">
                    <h6 className="mx-md-2 mx-sm-2">Employee Information</h6>
                    <div className="row">
                      {" "}
                      <Form.Group className="col-6 m-0">
                        {/* <Form.Label> First Name</Form.Label> */}
                        <Form.Control
                          type="text"
                          placeholder="First Name"
                          id="firstname"
                          name="firstname"
                          value={formData.firstname}
                          onChange={handleChange}
                        />
                        {errors.firstname && (
                          <div
                            className="text-danger"
                            style={{ fontSize: ".8rem" }}
                          >
                            {errors.firstname}
                          </div>
                        )}
                      </Form.Group>
                      <Form.Group className="col-6 m-0">
                        {/* <Form.Label> Middle Name</Form.Label> */}
                        <Form.Control
                          type="text"
                          placeholder="Middle Name"
                          id="middlename"
                          name="middlename"
                          value={formData.middlename}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </div>
                    <div className="row">
                      {" "}
                      <Form.Group className="col-6 m-0" controlId="lname">
                        {/* <Form.Label>Last Name</Form.Label> */}
                        <Form.Control
                          type="text"
                          placeholder="Last Name"
                          id="lastname"
                          name="lastname"
                          value={formData.lastname}
                          onChange={handleChange}
                        />
                        {errors.lastname && (
                          <div
                            className="text-danger"
                            style={{ fontSize: ".8rem" }}
                          >
                            {errors.lastname}
                          </div>
                        )}
                      </Form.Group>
                      <Form.Group className="col-6 m-0" controlId="phone">
                        {/* <label htmlFor="name">Mobile No</label> */}
                        <Form.Control
                          maxLength={10}
                          type="text"
                          placeholder="Mobile No"
                          id="mobile"
                          name="mobile"
                          value={formData.mobile}
                          onChange={handleChange}
                        />
                        {errors.mobile && (
                          <div
                            className="text-danger"
                            style={{ fontSize: ".8rem" }}
                          >
                            {errors.mobile}
                          </div>
                        )}
                      </Form.Group>
                    </div>

                    <div className="row">
                      <Form.Group className=" col-6 m-0" controlId="email">
                        {/* <label htmlFor="name">Email ID</label> */}
                        <Form.Control
                          type="email"
                          placeholder="Email ID"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                        />
                        {errors.email && (
                          <div
                            className="text-danger"
                            style={{ fontSize: ".8rem" }}
                          >
                            {errors.email}
                          </div>
                        )}
                      </Form.Group>
                      <Form.Group className=" col-6 m-0" controlId="Workemail">
                        {/* <label htmlFor="name">Email ID</label> */}
                        <Form.Control
                          type="email"
                          placeholder="Work Email ID"
                          id="workemail"
                          name="workemail"
                          value={formData.workemail}
                          onChange={handleChange}
                        />
                        {errors.workemail && (
                          <div
                            className="text-danger"
                            style={{ fontSize: ".8rem" }}
                          >
                            {errors.workemail}
                          </div>
                        )}
                      </Form.Group>
                    </div>
                    <div className="row">
                      <Form.Group className="col-6 m-0" controlId="Designation">
                        {/* <Form.Label>Designation</Form.Label> */}
                        <Form.Control
                          type="text"
                          id="designation"
                          placeholder="Designation"
                          name="designation"
                          value={formData.designation}
                          onChange={handleChange}
                        />
                        {errors.designation && (
                          <div
                            className="text-danger"
                            style={{ fontSize: ".8rem" }}
                          >
                            {errors.designation}
                          </div>
                        )}
                      </Form.Group>
                      <Form.Group className="col-6 m-0" controlId="Designation">
                        {/* <Form.Label>Designation</Form.Label> */}
                        <Form.Control
                          type="text"
                          id="qualification"
                          placeholder="Qualification"
                          name="qualification"
                          value={formData.qualification}
                          onChange={handleChange}
                        />
                        {errors.qualification && (
                          <div
                            className="text-danger"
                            style={{ fontSize: ".8rem" }}
                          >
                            {errors.qualification}
                          </div>
                        )}
                      </Form.Group>
                    </div>
                    <div className="row">
                      <Form.Group className="col-6 m-0" controlId="Department">
                        <Form.Control
                          as="select"
                          name="department"
                          value={formData.department}
                          onChange={handleChange}
                        >
                          <option value="">Department</option>
                          {departmentData.map((dept) => (
                            <option key={dept.id} value={dept.cat1}>
                              {dept.cat1}
                            </option>
                          ))}
                        </Form.Control>
                        {errors.department && (
                          <div
                            className="text-danger"
                            style={{ fontSize: ".8rem" }}
                          >
                            {errors.department}
                          </div>
                        )}
                      </Form.Group>
                      <Form.Group className="col-6 m-0" controlId="Emptype">
  <Form.Control
    as="select"
    name="emp_type"
    value={formData.emp_type}
    onChange={(e) => {
      if (e.target.value === "add_new") {
        setShowTypeModal(true);
      } else {
        handleChange(e);
      }
    }}
  >
    <option value="">Employee Type</option>

    {employeeTypes.map((item) => (
      <option key={item.id} value={item.type}>
        {item.type}
      </option>
    ))}

    <option value="add_new">+ Add Employee Type</option>
  </Form.Control>

  {errors.emp_type && (
    <div className="text-danger" style={{ fontSize: ".8rem" }}>
      {errors.emp_type}
    </div>
  )}
</Form.Group>
                    </div>
                    <div className="row">
                      <Form.Group className="col-6 m-0" controlId="Address">
                        {/* <label htmlFor="name">Enter Your Address</label> */}
                        <Form.Control
                          type="text"
                          id="address"
                          name="address"
                          placeholder="Enter Your address"
                          value={formData.address}
                          onChange={handleChange}
                        />
                        {errors.address && (
                          <div
                            className="text-danger"
                            style={{ fontSize: ".8rem" }}
                          >
                            {errors.address}
                          </div>
                        )}
                      </Form.Group>
                      <Form.Group className="col-6 m-0" controlId="DOB">
  <Form.Control
    type="date"
    value={formData.dob || ""}
    onChange={(e) =>
      setFormData({ ...formData, dob: e.target.value })
    }
    className="form-control"
    placeholder="Date of Birth"
  />
  {errors.dob && (
    <div className="text-danger" style={{ fontSize: ".8rem" }}>
      {errors.dob}
    </div>
  )}
</Form.Group>

                    </div>
                    <div className="row">
                      <Form.Group className="col-6 m-0" controlId="bankName">
                        {/* <label htmlFor="name">Enter Your Bank Name</label> */}
                        <Form.Control
                          type="text"
                          id="bankName"
                          name="bankName"
                          placeholder="Enter Your Bank Name"
                          value={formData.bankName}
                          onChange={handleChange}
                        />
                        {errors.bankName && (
                          <div
                            className="text-danger"
                            style={{ fontSize: ".8rem" }}
                          >
                            {errors.bankName}
                          </div>
                        )}
                      </Form.Group>
                      <Form.Group className="col-6 m-0" controlId="pan">
                        <Form.Control
                          type="text"
                          placeholder="PAN"
                          id="pan"
                          name="pan"
                          value={formData.pan}
                          onChange={handleChange}
                        />
                        {errors.pan && (
                          <div
                            className="text-danger"
                            style={{ fontSize: ".8rem" }}
                          >
                            {errors.pan}
                          </div>
                        )}
                      </Form.Group>
                    </div>
                    <div className="row">
                      <Form.Group className="col-5 m-0" controlId="ifscCode">
                        {/* <label htmlFor="name">Enter Your Bank ifscCode</label> */}
                        <Form.Control
                          type="text"
                          id="ifscCode"
                          name="ifscCode"
                          placeholder="Enter Your Bank ifscCode"
                          value={formData.ifscCode}
                          onChange={handleChange}
                        />
                        {errors.ifscCode && (
                          <div
                            className="text-danger"
                            style={{ fontSize: ".8rem" }}
                          >
                            {errors.ifscCode}
                          </div>
                        )}
                      </Form.Group>

                      <Form.Group
                        className="col-4 m-0 p-0"
                        controlId="accountNumber"
                      >
                        <Form.Control
                          type="text"
                          placeholder="Bank Account Number"
                          id="accountNumber"
                          name="accountNumber"
                          value={formData.accountNumber}
                          onChange={handleChange}
                        />
                        {errors.accountNumber && (
                          <div
                            className="text-danger"
                            style={{ fontSize: ".8rem" }}
                          >
                            {errors.accountNumber}
                          </div>
                        )}
                      </Form.Group>
                      <div className="col-3">
                        {/* <MdOutlineVerified
                          style={{ fontSize: "1.5rem", color: "green" }}
                          onClick={handleVerification}
                        /> */}
                        <Button size="sm"   onClick={handleVerification}>Verify Account</Button>
                      </div>
                    </div>
                    {verificationMessage && (
                      <div
                        className="text-success mx-2"
                        style={{ fontSize: ".9rem" }}
                      >
                        {verificationMessage}
                      </div>
                    )}
                    <div className="row">
                    <Form.Group className="col-6 m-0" controlId="joiningdate">
  <Form.Control
    type="date"
    value={formData.joiningdate || ""}
    onChange={(e) =>
      setFormData({ ...formData, joiningdate: e.target.value })
    }
    className="form-control"
    placeholder="Joining Date"
  />
  {errors.joiningdate && (
    <div className="text-danger" style={{ fontSize: ".8rem" }}>
      {errors.joiningdate}
    </div>
  )}
</Form.Group>

                    </div>
                    <div className="mx-md-2 mx-sm-2 ">
                      <Link>
                        <button
                          // type="submit"
                          className="btn btn-primary d-flex align-items-center "
                          style={{ height: "2rem", borderRadius: ".4rem" }}
                          onClick={validate}
                        >
                          Submit
                        </button>
                      </Link>
                    </div>
                  </form>
                </Col>
              </Row>
            </Tab.Container>
          </div>
        </div>
      </div>
      <Modal show={showTypeModal} onHide={() => setShowTypeModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Add Employee Type</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <Form.Control
      type="text"
      placeholder="Enter Employee Type"
      value={newEmpType}
      onChange={(e) => setNewEmpType(e.target.value)}
    />
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowTypeModal(false)}>
      Cancel
    </Button>

    <Button variant="primary" onClick={handleAddEmployeeType}>
      Save
    </Button>
  </Modal.Footer>
</Modal>
    </>
  );
};

export default EmployeeFormAdmin;
